<template>
    <div>
        <b-modal
            :no-close-on-backdrop="true" 
            scrollable 
            centered 
            size="xl"  
            @hide="this.emitEventCancel"
            :id="ModalIdAuditAuth" 
            :title="this.$t('Shared.AuditTitle')"  
            :ok-title="$t('Shared.Close')" 
            @ok="this.emitEventCancel" 
            style="padding:none!important" 
            ok-only
        >
            <b-row>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ this.$t('AuditList.Resume') }}</h6>
							</div>
                            <div class="flex-container">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.Date') }}</small><br>
                                            <b>{{ this.date }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.Address') }}</small><br>
                                            <b>{{ this.address }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ this.title }}</h6>
							</div>
                            <div class="flex-container">
                                <div class="row">
                                    <div class="col-md-6" v-for="(item, index) in this.items()" :key="`KY-${index}`">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ item.name }}</small><br>
                                            <b>{{ item.value }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'AuditAuthDialog',

    props: {
        VisibleDialog:Boolean,
        value: Object
    },

    data() {
        return {
            ModalIdAuditAuth: 'ModalIdAuditAuth'
        };
    },

    watch: {
        VisibleDialog(newVal) {
            if (newVal) {
                this.$bvModal.show(this.ModalIdAuditAuth);
            }
        }
    },

    computed: {
        title() {
            return this.value ? `${this.$t('AuditList.Info')}: ${this.value.actionTrans}` : '';
        },

        date() {
            return this.value ? this.value.sysDate : '';
        },

        address() {
            return this.value ? this.value.ipAddress : '';
        }
    },

    methods: {
        emitEventCancel() {
            this.$bvModal.hide(this.ModalIdAuditAuth);
            this.$emit('close');
        },

        items() {
            if (this.value) {
                const obj = JSON.parse(this.value.payload);
                
                let data = [];
                switch (this.value.action) {
                    case "WAA_LOGIN":
                        data = [
                            {name: this.$t('Shared.User'), value: this.value.userName},
                            {name: this.$t('Shared.ClientId'), value: obj['Login']['ClientId']},
                            {name: this.$t('Shared.ProviderId'), value: obj['Login']['ProviderId']},
                            
                        ];
                        break;
                    case "WAA_LOGOUT":
                        data = [
                            {name: this.$t('Shared.User'), value: this.value.userName},
                            {name: this.$t('Shared.ClientId'), value: obj['Logout']['ClientId']},
                            {name: this.$t('Shared.ProviderId'), value: obj['Logout']['ProviderId']},
                        ];
                        break;
                    default:
                    data = [
                            {name: this.$t('Shared.User'), value: this.value.userName},
                            {name: this.$t('Shared.ClientId'), value: obj['Unauthorized']['ClientId']},
                            {name: this.$t('AuditAuth.Request'), value: obj['Unauthorized']['Request']},
                            {name: this.$t('AuditAuth.Parameters'), value: obj['Unauthorized']['QueryString']},
                        ];
                        break;
                }

                return data;
            }
            
            return [];
        }
    }
}
</script>